module.exports = __webpack_public_path__ + "img/symbol_7.dc0f76c4.png";